module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "plat-icon-flowSubmitDialog",
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogVisible,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.flowLoading),
      expression: "flowLoading"
    }],
    staticClass: "plat-icon-Dialog"
  }, [_c('div', {
    staticClass: "plat-icon-DialogContent"
  }, [_c('div', {
    staticClass: "plat-icon-FlowSubmit"
  }, [_c('h3', [_vm._v("\n          " + _vm._s(_vm.$_t(
    '选择签核流程 (下拉框中可能存在多个可选项目,请注意选择合适的流程)',
    'ChooseSignFlow'
  )) + "\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('el-select', {
    attrs: {
      "disabled": _vm.isDisabled
    },
    model: {
      value: (_vm.selectednew_flowid),
      callback: function($$v) {
        _vm.selectednew_flowid = $$v
      },
      expression: "selectednew_flowid"
    }
  }, _vm._l((_vm.flowList), function(flow) {
    return _c('el-option', {
      key: flow.new_flowid,
      attrs: {
        "value": flow.new_flowid,
        "label": flow.new_name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "plat-icon-FlowSteps"
  }, [_c('h3', [_vm._v("\n            " + _vm._s(_vm.$_t('选择签核用户', 'ChooseSignUser')) + "\n          ")]), _vm._v(" "), _vm._l((_vm.stepList), function(step) {
    return _c('div', {
      key: step.new_name,
      staticClass: "plat-icon-FlowStep"
    }, [_c('br'), _vm._v(" "), _c('h4', [_vm._v("\n              " + _vm._s(step.new_name) + "\n              "), (step.new_approvalway == 1) ? _c('span', [_vm._v("\n                " + _vm._s(_vm.$_t(
      '(下拉框中可能存在多个可选人员,请注意选择合适的下一级呈递人)',
      'ChooseSignUser_default'
    )) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (
      step.new_approvalway == 2 ||
      step.new_approvalway == 3 ||
      step.new_approvalway == 4
    ) ? _c('div', {
      staticClass: "plat-icon-FlowStep-div"
    }, _vm._l((step.new_stepusers), function(user) {
      return _c('span', {
        key: user.systemuserid
      }, [_vm._v("\n                " + _vm._s(user.fullname) + "\n              ")])
    }), 0) : _c('div', [_c('el-select', {
      model: {
        value: (step.ApproveUserId),
        callback: function($$v) {
          _vm.$set(step, "ApproveUserId", $$v)
        },
        expression: "step.ApproveUserId"
      }
    }, _vm._l((step.new_stepusers), function(user) {
      return _c('el-option', {
        key: user.systemuserid,
        attrs: {
          "value": user.systemuserid,
          "label": user.fullname
        }
      })
    }), 1)], 1)])
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "plat-icon-DialogFooter"
  }, [_c('div', {
    staticClass: "plat-icon-DialogButtons"
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.btnloading,
      "disabled": _vm.disabledSubmit
    },
    on: {
      "click": _vm.submitFlow
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关闭")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e113245"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/flowsubmit/src/flow-submit.vue
// module id = 2033
// module chunks = 228